<template>
  <div class="border rounded-md">
    <table class="table table-fixed w-full">
      <slot />
    </table>
  </div>
</template>
